export enum DeliveryTypes {
    Download = 1,
    Email = 2
}